import { FaArrowRight } from "react-icons/fa";
import WhatsappLink from "../../../utils/WhatsappLink";

const CARDS = [
  "Somos una empresa Agtech con el compromiso de actuar con profesionalismo, desarrollando productos de última tecnología, que generen resultados positivos y tangibles para los clientes.",
  "Nuestro equipo cuenta con la motivación, los recursos, conocimientos, la experiencia para dar los mejores resulta-dos y muchas ganas de acompañarte en cada paso.",
  "Creemos en la transparencia, el diálogo abierto y el trabajo en equipo. Queremos que tomes decisiones informadas, que compartas lo que sabés y que crezcamos juntos.",
];

export const HeroSection = () => {
  return (
    <section
      className="light-section"
      style={{ marginTop: "4rem", marginBottom: "2rem" }}
    >
      <img
        src={`${process.env.PUBLIC_URL}/assets/imagenes/home/fondo_puntitos.png`}
        className="background-dots"
        // style={{ objectFit: "fill" }}
        alt="background1"
      />
      <div className="columna">
        <span className="horizontal gap-8" style={{ marginBottom: 24 }}>
          <span className="linea-negra"></span>
          <p className="datos-upper-text">Sobre nosotros</p>
        </span>

        <p className="section-title">
          <span>
            Tenemos la misión de
            <br />
            empoderar al ecosistema
            <br />
            <span style={{ color: "var(--red-highlight)" }}>
              {" "}
              agroindustrial
            </span>
          </span>
        </p>

        <p className="section-subtitle">
          Creamos productos que permiten captar,
          <br />
          retener y rentabilizar clientes, además de facilitar la
          <br />{" "}
          <span className="underscore">
            toma de decisiones{" "}
            <img
              style={{}}
              src={`${process.env.PUBLIC_URL}/assets/imagenes/subrayado2-21.png`}
              alt="subrayado"
            />
          </span>
          mediante el uso y <br /> conocimiento de sus datos.
        </p>

        <div
          style={{
            width: "70%",
            marginTop: "3rem",
            marginInline: "auto",
            backgroundColor: "white",
          }}
        >
          <img
            alt="client-meeting"
            src={`${process.env.PUBLIC_URL}/assets/imagenes/about/may-09.png`}
            style={{ width: "100%", position: "relative", zIndex: 1 }}
          />
        </div>
      </div>
      <div className="columna">
        <div className="about-cards-layout">
          {CARDS?.map((text, index) => {
            return (
              <div className="about-card-wrapper" key={`about-card-${index}`}>
                <img
                  alt="estrella"
                  src={`${process.env.PUBLIC_URL}/assets/imagenes/about/estrella-32.png`}
                  style={{
                    width: "4.5rem",
                    position: "absolute",
                    top: 0,
                    left: 0,
                    transform: "translate(-50%, -50%)",
                  }}
                />
                <p className="card-text">{text}</p>
              </div>
            );
          })}
          <span
            className="horizontal gap-16"
            style={{ width: "auto", marginInline: "auto" }}
          >
            {/* <button className="boton-generico boton-blanco">
              <p>Preguntas frecuentes</p>
              <FaArrowRight />
            </button> */}
            <WhatsappLink>
              <button className="boton-generico boton-blanco">
                <p>Más info</p>
                <FaArrowRight />
              </button>
            </WhatsappLink>
          </span>
        </div>
      </div>
    </section>
  );
};
